import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Kundengruppe } from '../entities/customers/kundengruppe.entity';
import { Kundensegment } from '../entities/customers/kundensegment.entity';
//#endregion

@Injectable()
export class KundensegmentService extends ODataEntityService<Kundensegment> {
  constructor(protected client: ODataClient) {
    super(client, 'Kundensegment', 'entities.customers.Kundensegment');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public kundengruppe(entity: EntityKey<Kundensegment>): ODataNavigationPropertyResource<Kundengruppe> {
    return this.entity(entity).navigationProperty<Kundengruppe>('kundengruppe');
  }
  //#endregion
}
